module.exports = __webpack_public_path__ + "static/media/black.7ebf1ef4.svg";